import script from "./Recipe.vue?vue&type=script&setup=true&lang=js"
export * from "./Recipe.vue?vue&type=script&setup=true&lang=js"

import "./Recipe.vue?vue&type=style&index=0&id=139262da&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-139262da"]])

export default __exports__